import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid } from "@material-ui/core";
import { HeaderHLPure, DialogSystemGLPure, GridPure, SearchBarHLPure, ButtonAddHLPure, ModalUtil } from "../../pures";
import { useHistory } from 'react-router-dom'
import Swal from 'sweetalert2'
import "./branch-office.css";
import branchOfficeImg from '../../../assets/modal-icons/branch-office.png'
import multipleBranchOfficeImg from '../../../assets/modal-icons/multiple-branch-office.png'

const BranchOfficeView = (props) => {
  const { t } = useTranslation('branch-office', { keyPrefix: 'branchOfficeScreen' })
  const { t: tGeneral } = useTranslation()
  const history = useHistory()
  const [selectedValueFilter, setSelectedValue] = useState("Pendiente")
  const modalUtil = new ModalUtil()
  const [searchBranch, setSearchBranch] = useState('');

  const handleSearch = (e) => setSearchBranch(e.target.value);

  const strToboolean = (value) => {
    if (value && typeof value === "string") {
      if (value.toLowerCase() === "true") return true;
      if (value.toLowerCase() === "false") return false;
    }
    return value;
  };

  const filterChange = (e) => {
    const selectedOption = strToboolean(e.target.value);
    setSelectedValue(selectedOption);
  };

  const data = props.branchOffices

  const branchesGrid = useMemo(() => {
    if (!searchBranch) return data
    const filteredData = data.filter(el => el.name.toLowerCase().includes(searchBranch.toLowerCase()) ||
      el.name.includes(searchBranch.toLowerCase()))
    return filteredData
  }, [data, searchBranch])

  const selectOption = () => {
    modalUtil.customModal({
      modalTitle: t('modalTitle'),
      id1: 'individual-branch-office',
      title1: t('modalOptionTitle1'),
      text1: t('modalText1'),
      image1: branchOfficeImg,
      imageStyle1: '50px;',
      id2: 'multiple-branch-office',
      title2: t('modalOptionTitle2'),
      text2: t('modalText2'),
      image2: multipleBranchOfficeImg,
      imageStyle2: '100px;'
    }, () => {
      document.getElementById('individual-branch-office').addEventListener('click', () => {
        history.push('branch-office-details')
        Swal.close()
      })

      document.getElementById('multiple-branch-office').addEventListener('click', () => {
        history.push('create-branch-offices')
        Swal.close()
      })
    })
  }

  return (
    <Container className="branchOfficeView view-container">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <HeaderHLPure title={t("title")} />
        </Grid>
        <Grid item xs={12} className="add-and-search-container">
          <ButtonAddHLPure
            iconAdd={true}
            nameBtn={t('buttonAdd')}
            onClick={() => { selectOption() }}
          />
          <SearchBarHLPure
            placeholder={tGeneral("search")}
            labelFilter="Filtrar por"
            options={props.optionsFilter}
            nameOption="status"
            statusValueFilter={selectedValueFilter === true ? "Activo" : selectedValueFilter === false ? "Inactivo" : "Todos"}
            optionsValue={"Todos"}
            onFilterChange={(e) => filterChange(e)}
            onSearchChange={e => handleSearch(e)}
          />
        </Grid>
        <Grid item xs={12}>
          <GridPure
            {...props}
            dataGrid={branchesGrid}
            skip={0}
            take={11}
            rowsItems={[{
              field: 'name',
              sorteable: true,
              title: t("columnName"),
              width: '30%'
            },
            {
              field: 'zipCode',
              sorteable: true,
              title: t("columnZipCode"),
              width: '15%'
            },
            {
              field: 'city',
              sorteable: true,
              title: t("columnCity"),
              width: '20%'
            },
            {
              field: 'state',
              sorteable: true,
              title: t("columnState"),
              width: '20%'
            },
            {
              field: 'Acciones',
              title: tGeneral("columnActions"),
              width: '15%',
              actions: true,
              headerClassName: 'actionHeader'
            }]}
            actions={[
              {
                type: 'view-details',
                value: tGeneral('gridPure.columnActions.details'),
                onClick: (dataItem) => { history.push(`branch-office-details?&branchOfficeId=${dataItem.id}`) }
              },
              {
                type: 'icon',
                value: 'k-icon k-i-delete k-i-trash',
                onClick: (dataItem) => { props.deleteBranchOffice(dataItem) }
              },
            ]}
            iconOneActive
            labelOneActions={t("configurationPanelView.delete.domain.btn")}
            activeDialog1
            styleCol1={"configurationDomainsView-style-col-1"}
            labelsColumnsNoPadding={false}
          />
        </Grid>
      </Grid>
      {/* Alerts of Notification Completed and Loading */}
      <DialogSystemGLPure
        toggleLoadingRequesting={props.toggleLoadingRequesting}
        showLoadingRequesting={props.showLoadingRequesting}
        toggleCompletedRequesting={props.toggleCompletedRequesting}
        toggleErrorRequesting={props.toggleErrorRequesting} />
    </Container>
  );
}

export { BranchOfficeView as default };